module.exports = __webpack_public_path__ + "img/Strata-Tech-Logo.b4ece3d8.png";